module.exports = __webpack_public_path__ + "img/web2.1c4820e4.png";